function authInterceptor(AppConstants, $window, $q, $state, $cookies, $rootScope) {
  'ngInject'

  return {
    request: function(config) {
      return config;
    },

    responseError: function(rejection) {
      // console.log('====', $window.location, rejection )
      if (rejection.status === 401) {
        $window.location.reload();
      }else if(rejection.status === 403) {
        localStorage.clear()
        $cookies.remove("user")
        $cookies.remove("ranger-session")
        $state.go('login')
      }else if(rejection.status === 404 || rejection.status <= 0){
        $rootScope.$broadcast("ServerError", rejection.status);
      }

      return $q.reject(rejection);
    }

  }
}

export default authInterceptor;



// WEBPACK FOOTER //
// ./client/app/config/auth.interceptor.js